import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { SessionBookingVM } from '../../../models/SessionBookingVM';
import * as moment from 'moment-timezone';
import { SessionDuration } from '../../../models/SessionDuration';

@Component({
  selector: 'account-confirm-session',
  templateUrl: './confirmsession.component.html'
})
export class ConfirmSessionComponent extends BaseComponent implements OnInit {

  sessionDetails: SessionBookingVM | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accService: AccountService
  ) {
    super(route);
  }

  ngOnInit(): void {
    this.sessionDetails = this.accService.newSessionBooking;
    if (this.sessionDetails == null) {
      this.router.navigateByUrl("/");
    }

    if (this.sessionDetails.payWithCredits) {
      //check if credits are still valid    
      var self = this;
      self.emitDisplayLoadingDialog(true);
      this.sessionDetails.duration
      this.accService.getSessionCreditsByProfessional(this.sessionDetails.mbNumber)
        .subscribe(
          r => {
            var stillHasCredits = false;
            r.forEach((item, i) => {
              if (item.duration == self.sessionDetails.duration) {
                stillHasCredits = true;
                self.sessionDetails.token = item.id;
              }
            });

            if (!stillHasCredits) {
              this.router.navigateByUrl("/");
            }

            self.emitDisplayLoadingDialog(false);
          },
          e => {
            console.log(e);
            this.router.navigateByUrl("/");
            self.emitDisplayLoadingDialog(false);
          },
          () => { }
        );
    }
  }

  cancel() {
    this.accService.newSessionBooking = null;
    this.router.navigateByUrl("/profile/" + (this.sessionDetails as SessionBookingVM).mbNumber);
  }

  continue() {
    this.router.navigateByUrl("/session-payment");
  }

}
